/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import InputRange from 'react-input-range';

// eslint-disable-next-line css-modules/no-unused-class
import s from './FilterLeft.css';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';
import IconCalendar from '../../../../public/images/ic_mini_calendar.png';

class FilterLeft extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fechaSeleccionada: this.props.fechaHeader,
      fecha: '',
      fechaSiguiente: this.props.fechaHeader,
      fechaAnterior: null,
      turno: '',
    };
  }

  componentDidMount() {
    if (this.props.fechasD) {
      this.props.load(3);
    }
    // this.validarTurnoTomado(
    //   this.props.formatDate(this.state.fechaSeleccionada, 's'),
    // );
  }

  render() {
    this.props.fechaPicker();
    return (
      <div className={'mt-0 card'}>
        <div className={`${s.container} card-body`}>
          <h6 className="mt-0">
            <strong> Horarios de Atención</strong>
          </h6>
          <div className={`${s.input_range}`}>
            <InputRange
              step={30}
              maxValue={this.props.maxValue}
              minValue={this.props.minValue}
              formatLabel={value => this.props.formatearHora(value)}
              value={this.props.value}
              onChange={value => this.props.change(value)}
              onChangeComplete={value => this.props.onChangeHorario({ value })}
            />
          </div>
          <div className={s.card_text}>
            <a
              className={s.first}
              onClick={() =>
                this.props.onClickHorarioChange({
                  min: 480,
                  max: 1200,
                })}
              role="button"
              tabIndex="0"
            >
              Todos
            </a>
            <a
              onClick={() =>
                this.props.onClickHorarioChange({
                  min: 480,
                  max: 720,
                })}
              role="button"
              tabIndex="0"
            >
              Mañana
            </a>
            <a
              onClick={() =>
                this.props.onClickHorarioChange({
                  min: 720,
                  max: 1050,
                })}
              role="button"
              tabIndex="0"
            >
              Tarde
            </a>
            <a
              className={s.last}
              onClick={() =>
                this.props.onClickHorarioChange({
                  min: 1050,
                  max: 1200,
                })}
              role="button"
              tabIndex="0"
            >
              Noche
            </a>
          </div>
        </div>
        <ul className="list-group list-group-flush">
          <li className={` ${s.container} list-group-item`}>
            <h6 className="mt-0">
              <strong> Fecha de Atención</strong>
            </h6>
            <h4 id="calendario" style={{ margin: '0', display: 'inline' }}>
              <input
                type="text"
                value={this.props.fecha}
                onChange={this.props.changeDate}
                className="form-control fechaInput"
                placeholder="Fecha"
              />
              <img
                alt="calendario"
                src={IconCalendar}
                style={{
                  position: 'absolute',
                  top: '54px',
                  left: '208px',
                }}
              />
            </h4>
          </li>
          {/* <li className={` ${s.container} list-group-item`}>
            <h6 className="mt-0">
              <strong> Profesionales</strong>
            </h6>
          </li> */}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  // fechasDisponibles: state.telemedicina.fechas_disponibles,
  turnosPorFecha: state.telemedicina.turnos_por_fecha,
  practica: state.telemedicina.practica,
  prepaga: state.telemedicina.prepaga,
});

export default connect(mapStateToProps, telemedicinaActions)(
  withStyles(s)(FilterLeft),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/FilterLeft/FilterLeft.js